<template>
    <span class="text-muted" v-html="defaultSlot" />
</template>

<script>
export default {
    name: 'SimpleTextLine',
    computed: {
        defaultSlot() {
            return this.$slots.default[0].text
        },
    },
}
</script>
